var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMinus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 2,
    viewBox: "0 0 12 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.35123 1.26204C1.15725 1.26204 1 1.10479 1 0.910805C1 0.716824 1.15725 0.559571 1.35123 0.559571L10.3165 0.55957C10.5105 0.55957 10.6677 0.716823 10.6677 0.910804C10.6677 1.10479 10.5105 1.26204 10.3165 1.26204L1.35123 1.26204Z",
    fill: "#383838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3165 1.26204V0.762038V1.26204ZM10.3165 0.55957V0.0595703V0.55957ZM1.35123 0.559571L1.35123 1.05957L1.35123 0.559571ZM1.35123 1.26204L1.35123 1.76204L1.35123 1.26204ZM1.35123 1.05957L10.3165 1.05957V0.0595703L1.35123 0.0595707L1.35123 1.05957ZM10.3165 0.762038L1.35123 0.762038L1.35123 1.76204L10.3165 1.76204V0.762038ZM10.1677 0.910804C10.1677 0.828643 10.2343 0.762038 10.3165 0.762038V1.76204C10.7866 1.76204 11.1677 1.38093 11.1677 0.910804L10.1677 0.910804ZM10.3165 1.05957C10.2343 1.05957 10.1677 0.992965 10.1677 0.910804L11.1677 0.910804C11.1677 0.440682 10.7866 0.0595703 10.3165 0.0595703V1.05957ZM1.5 0.910805C1.5 0.992966 1.4334 1.05957 1.35123 1.05957L1.35123 0.0595707C0.88111 0.0595707 0.5 0.440681 0.5 0.910805L1.5 0.910805ZM0.5 0.910805C0.5 1.38093 0.881109 1.76204 1.35123 1.76204L1.35123 0.762038C1.4334 0.762038 1.5 0.828644 1.5 0.910805L0.5 0.910805Z",
    fill: "#383838"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.84e078330c868d1378b0adba31cdcc01.svg";
export { ForwardRef as ReactComponent };